var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: { title: _vm.title, visible: _vm.drawer, size: "80%" },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.drawer
            ? _c("OperationStopPower", {
                attrs: { isLog: true, devId: _vm.row.Id },
                on: { view: _vm.view },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("EditForm", { ref: "EditForm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }